import React, { useEffect, useState, useRef } from 'react'
import HideAppBar from './components/HideAppBar'
import Banner from './components/Banner';
import Register from './components/Register';
import DashboardManage from './components/DashboardManage';
import GalleryShow from './components/GalleryShow';
import Footer from './components/Footer';
import { FnAxios, FnDialog } from 'utilities/utilities';
import MenuHomeAll from './components/MenuHomeAll';
import AboutUs from './components/Contact';
import { Hidden, useMediaQuery } from '@mui/material';
import { useScrollPosition } from './useScrollPosition';

export const ProviderLayout = React.createContext(null);

const Homepage = () => {

    const LayoutWeb = useMediaQuery('(min-width:1180px)');

    const bannerRef = useRef(null);
    const registerRef = useRef(null);
    const dashboardRef = useRef(null);
    const galleryRef = useRef(null);
    const aboutusRef = useRef(null);


    const [bannerData, setBannerData] = useState([]);
    const [arrGallery, setGalleryData] = useState([]);
    const [colorSideMenu, setColorSideMenu] = useState("#fbdf84")
    const [hideOnScroll, setHideOnScroll] = useState(true)

    useScrollPosition(
        ({ prevPos, currPos }) => {
            const isShow = currPos.y > prevPos.y
            if (isShow !== hideOnScroll) setHideOnScroll(isShow)
        },
        [hideOnScroll]
    )

    const DialogFn = FnDialog();
    const AxiosFn = FnAxios();
    const onLoadData = () => {
        DialogFn.BlockUI();
        AxiosFn.Get("Home/GetHomeData", {}, (res) => {
            DialogFn.UnBlockUI();
            setBannerData(res.lstHome ?? []);
            setGalleryData(res.lstGallery ?? [])
        }).then(
            () => {
                DialogFn.UnBlockUI();
            }
        );
    }

    useEffect(() => {
        onLoadData();
    }, []);

    useEffect(() => {
        const handleScroll = () => {

            if (aboutusRef.current) {
                const { top, bottom } = aboutusRef.current.getBoundingClientRect();
                const windowHeight = window.innerHeight || document.documentElement.clientHeight;
                const visible = (top >= 0 && bottom <= windowHeight) || (top <= windowHeight && bottom >= 0);
                if (visible) {
                    setColorSideMenu("#9d554b")
                }
            }


            if (galleryRef.current) {
                const { top, bottom } = galleryRef.current.getBoundingClientRect();
                const windowHeight = window.innerHeight || document.documentElement.clientHeight;
                const visible = (top >= 0 && bottom <= windowHeight) || (top <= windowHeight && bottom >= 0);
                if (visible) {
                    setColorSideMenu("#a17560")
                }
            }

            if (dashboardRef.current) {
                const { top, bottom } = dashboardRef.current.getBoundingClientRect();
                const windowHeight = window.innerHeight || document.documentElement.clientHeight;
                const visible = (top >= 0 && bottom <= windowHeight) || (top <= windowHeight && bottom >= 0);
                if (visible) {
                    setColorSideMenu("#ebb464")
                }
            }

            if (registerRef.current) {
                const { top, bottom } = registerRef.current.getBoundingClientRect();
                const windowHeight = window.innerHeight || document.documentElement.clientHeight;
                const visible = (top >= 0 && bottom <= windowHeight) || (top <= windowHeight && bottom >= 0);
                if (visible) {
                    setColorSideMenu("#facc8a")
                }
            }

            if (bannerRef.current) {
                const { top, bottom } = bannerRef.current.getBoundingClientRect();
                const windowHeight = window.innerHeight || document.documentElement.clientHeight;
                const visible = (top >= 0 && bottom <= windowHeight) || (top <= windowHeight && bottom >= 0);
                if (visible) {
                    setColorSideMenu("#fbdf84")
                }
            }
        };

        // Initial check
        handleScroll();

        // Listen for scroll events to check visibility
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <div style={{ width: "100%" }}>
            {LayoutWeb ? (
                <>
                    <MenuHomeAll
                        classMenu={
                            !hideOnScroll
                                ? "div-MenuListAllScroll div-MenuListAll"
                                : "div-MenuListAll"
                        }
                        IsPreview={false}
                        sColor={colorSideMenu}
                        bannerRef={bannerRef}
                        registerRef={registerRef}
                        dashboardRef={dashboardRef}
                        galleryRef={galleryRef}
                        aboutusRef={aboutusRef}
                    />
                    <HideAppBar />
                    <div ref={bannerRef} id={"banner-Id"}>
                        <Banner
                            bannerData={bannerData}
                            IsPreview={false}
                            registerRef={registerRef}
                        />
                    </div>
                    <div ref={registerRef} id={"register-Id"}>
                        <Register IsPreview={false} />
                    </div>
                    <div ref={dashboardRef} id={"dashboard-Id"}>
                        <DashboardManage />
                    </div>
                    <div ref={galleryRef} id={"gallry-Id"}>
                        <GalleryShow Gallery={arrGallery} IsPreview={false} />
                    </div>
                    <div ref={aboutusRef} id={"about-Id"}>
                        <AboutUs />
                    </div>
                    <Footer isMap={true}/>
                </>
            ) : (
                <>
                    <HideAppBar />
                    <div style={{ marginTop: "64px" }}></div>
                    <Banner bannerData={bannerData} IsPreview={false} />
                    <Register IsPreview={false} />
                    <DashboardManage />
                    <GalleryShow Gallery={arrGallery} IsPreview={false} />
                    <AboutUs />
                    <Footer isMap={true}/>
                </>
            )}
        </div>
    );
}

export default Homepage